// src/utils/HtmlMarker.js
export function HtmlMarker(position, map, html, onClick, onReady) {
    if (typeof window === "undefined" || !window.google?.maps) {
        console.error("Google Maps API no está cargada: HtmlMarker cancelado");
        return null;
    }

    class _HtmlMarker extends window.google.maps.OverlayView {
        constructor(position, map, html, onClick, onReady) {
            super();
            this.position = position;
            this.basePosition = position;
            this.html = html;
            this.onClick = typeof onClick === "function" ? onClick : null;

            this.onReady = typeof onReady === "function" ? onReady : null;

            this.div = null;
            this.isHidden = false;

            this.setMap(map);
        }

        onAdd() {
            this.div = document.createElement("div");
            Object.assign(this.div.style, {
                position: "absolute",
                cursor: this.onClick ? "pointer" : "default",
                transform: "translate(-50%, -50%)",
                willChange: "transform,left,top",
            });

            this.div.innerHTML = this.html;

            // overlayMouseTarget = recibe eventos de mouse
            this.getPanes().overlayMouseTarget.appendChild(this.div);

            if (this.onClick) {
                this._clickHandler = (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    this.onClick();
                };
                this.div.addEventListener("click", this._clickHandler);
            }

            // ✅ aquí ya existe el div -> dispara callback
            if (this.onReady) this.onReady(this.div, this);
        }

        draw() {
            if (!this.div) return;

            this.div.style.display = this.isHidden ? "none" : "block";
            if (this.isHidden) return;

            const projection = this.getProjection();
            if (!projection) return;

            const p = projection.fromLatLngToDivPixel(this.position);
            if (!p) return;

            this.div.style.left = `${p.x}px`;
            this.div.style.top = `${p.y}px`;
        }

        onRemove() {
            if (this.div) {
                if (this._clickHandler) this.div.removeEventListener("click", this._clickHandler);
                this.div.remove();
                this.div = null;
            }
        }

        setPosition(latLng) {
            this.position = latLng;
            this.draw();
        }

        setHtml(html) {
            this.html = html;
            if (this.div) {
                this.div.innerHTML = html;
            }
        }

        setBasePosition(latLng) {
            this.basePosition = latLng;
        }

        resetToBase() {
            this.position = this.basePosition;
            this.isHidden = false;
            this.draw();
        }

        setHidden(v) {
            this.isHidden = !!v;
            this.draw();
        }
    }

    return new _HtmlMarker(position, map, html, onClick, onReady);
}
